import { render, staticRenderFns } from "./BulkInput.vue?vue&type=template&id=25baedb8&"
import script from "./BulkInput.vue?vue&type=script&lang=js&"
export * from "./BulkInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports